import { render, staticRenderFns } from "./CspDialog.vue?vue&type=template&id=be963a90&scoped=true"
import script from "./CspDialog.vue?vue&type=script&lang=ts"
export * from "./CspDialog.vue?vue&type=script&lang=ts"
import style0 from "./CspDialog.vue?vue&type=style&index=0&id=be963a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be963a90",
  null
  
)

export default component.exports